export default "__VITE_ASSET__df742693__"